<template>
    <div class="box">
        <div class="upper">
            <div class="loopBox">
                <div v-for="(item, index) in loop1" :key="index"
                    :style="{ height: item, 'background-color': color, width: 2 + 'px', 'border-radius': 2 + 'px' }">
                </div>
            </div>
            <div class="title">{{ title }}</div>
            <div class="loopBox">
                <div v-for="(item, index) in loop2" :key="index"
                    :style="{ height: item, 'background-color': color, width: 2 + 'px', 'border-radius': 2 + 'px' }">
                </div>
            </div>
        </div>
        <div class="lower">{{ eTitle }}</div>
    </div>
</template>
<script>
export default {
    name: 'colorfulTitle',
    data() {
        return {
            loop1: ['28px', '20px', '12px', '16px'],
            loop2: ['16px', '12px', '20px', '28px'],
            currentIndex: 0
        }
    },
    props: {
        title: String,
        eTitle: String,
        color: {
            type: String,
            default: 'blue'
        }
    },
}
</script>
<style scoped>
.box {
    width: auto;
    height: auto;
    margin: 0 auto;
}

.upper {
    display: flex;
    justify-content: center;
    align-items: center;
}

.loopBox {
    width: 28px;
    height: 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    margin: 0 16px;
    font-weight: bold;
    font-style: normal;
    font-size: 36px;
    line-height: 54px;
    text-align: center;
}

.lower {
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    line-height: 14px;
    text-align: center;
    color: #D9D9D9;
}
</style>